import React, { useContext, useState } from 'react'
import axios from 'axios'
import {
  Container,
  CancelButton,
  SaveButtonDiv,
  SaveButtonImage,
  SaveButtonText,
} from './style'
import save from '../../../../assets/certificates/AddParameter/save.svg'
import SectionContext from '../../../../contexts/SectionContext'
import CertificatesContext, { CertificateObject } from '../../../../contexts/CertificatesContext'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import { useNavigate } from 'react-router-dom'

interface propsType{
  withoutSave?:boolean
}

const AddCertifateButtonsDiv: React.FC<propsType> = (props) => {
  const { certificate, structureData } = useContext(CertificatesContext)
  const { certificatesSection, setCertificatesSection } = useContext(SectionContext)
  const { setFeedback } = useContext(FeedbackContext)
  const navigate = useNavigate()

  const handleSubmit = () => {
    if (certificatesSection === 'newCertificate'){
      handleNewCertificateSubmit()
    } else {
      handleEditCertificateSubmit()
    }
  }

  const handleNewCertificateSubmit = () => {
    const formData = new FormData()
  
    Object.keys(certificate).forEach((key) => {
      if (key !== 'structures' && key !== 'customerCompany' && key !== 'supplierCompany') {
        formData.append(key, certificate[key as keyof CertificateObject] as string)
      }
    })
  
    formData.append('customerCompanyId', certificate.customerCompany.id.toString())
    formData.append('supplierCompanyId', certificate.supplierCompany.id.toString())
    formData.append('heatNumberId', certificate.heatNumber.id.toString())
    formData.append('certificateTypeId', certificate.type.id.toString())
  
    // Criamos um array de estruturas e depois adicionamos ao formData
    const structuresData = structureData.map((structure, index) => {
      const structureObject: any = {
        id: structure.id || null,
        name: structure.name,
        fileImport: structure.fileImport ? 'true' : 'false',
        hasTable: structure.hasTable ? 'true' : 'false',
        tableData: structure.tableData,
        tableRows: structure.tableRows,
        tableColumns: structure.tableColumns,
        format: structure.format,
        structureFile: structure.structureFile ? structure.structureFile.name : null,
      }
  
      // Se houver um arquivo, adicionamos ao formData
      if (structure.structureFile) {
        formData.append(`files`, structure.structureFile)
      }
  
      return structureObject
    })
  
    // Adicionamos todas as estruturas como um único campo JSON no formData
    formData.append('structures', JSON.stringify(structuresData))
  
    const certificateUrl = process.env.REACT_APP_CERTIFICATES_BASE_URL
  
    axios
      .post(`${certificateUrl}/certificate`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(() => {
        setTimeout(() => {
          window.location.reload()
        }, 2000)
        setFeedback({
          isOpen: true,
          message: 'Sucesso ao criar certificado',
          statusOk: true,
        })
      })
      .catch((error) => {
        setFeedback({
          isOpen: true,
          message: 'Erro ao criar certificado',
          statusOk: false,
        })
        console.log(error)
      })
  }

  const handleEditCertificateSubmit = () => {
    console.log('Editando certificado')
  }

  return (
    <Container>
      <CancelButton onClick={() => navigate('../')}>Cancelar</CancelButton>
        <SaveButtonDiv onClick={handleSubmit}>
          <SaveButtonImage src={save} alt='Right arrow icon'/>
          <SaveButtonText>
            {certificatesSection == 'newCertificate' && 'Salvar certificado'}
            {certificatesSection == 'editCertificate' && 'Editar certificado'}
          </SaveButtonText>
        </SaveButtonDiv>
    </Container>
  )
}

export default AddCertifateButtonsDiv
